import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { GLOBAL } from '../utils/translation';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private platformId = inject(PLATFORM_ID);
  availableLanguages = ['pt-br', 'en-us', 'es-es'];
  globalLang: any = GLOBAL;

  currentLang = signal('pt-br');
  translations = signal(this.globalLang.languages['pt-br']);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const saved = localStorage.getItem('lang') || 'pt-br';
      this.setLanguage(saved);
    }
  }

  setLanguage(lang: string) {
    const selectedLang = this.globalLang.languages[lang] ? lang : 'pt-br';

    this.currentLang.set(selectedLang);
    this.translations.set(this.globalLang.languages[selectedLang]);
    localStorage.setItem('lang', selectedLang);
  }
}
